import React, { useEffect, useState } from 'react';
import styles from './VerticalNavigation.module.scss';

export const VerticalNavigation = ({ activeStep, pageList, onChange }) => {
  const [sectionName, setSectionName] = useState('how');

  const setSection = (newSection) => {
    const currentPage = pageList.find((item) => item.name === newSection);

    if (currentPage) {
      onChange(currentPage.index);
      setSectionName(currentPage.name);
    }
  };

  useEffect(() => {
    const currentPage = pageList.find((item) => item.index === activeStep);

    if (currentPage) {
      setSectionName(currentPage.name);
    }
  }, [activeStep]);

  return (
    <div className={styles.navigationWrapper}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <div
          className={styles.divRight}
          style={{
            background: sectionName.includes('how') ? '' : undefined,
          }}
          onClick={() => setSection('how')}
        >
          <div className={`${styles.textRight} ${sectionName.includes('how') ? styles.big : ''}`}>
            How does it work?
          </div>
          <div className={styles.numberRight}>{sectionName.includes('how') ? '1' : ''}</div>
        </div>
        {sectionName.includes('how') && (
          <div
            className={styles.numRight}
            style={{
              background: sectionName === 'how_1' ? '#757575' : undefined,
            }}
            onClick={() => setSection('how_1')}
          />
        )}
        {sectionName.includes('how') && (
          <div
            className={styles.numRight}
            style={{
              background: sectionName === 'how_2' ? '#757575' : undefined,
            }}
            onClick={() => setSection('how_2')}
          />
        )}
        {sectionName.includes('how') && (
          <div
            className={styles.numRight}
            style={{
              background: sectionName === 'how_3' ? '#757575' : undefined,
            }}
            onClick={() => setSection('how_3')}
          />
        )}
      </div>

      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <div
          className={styles.divRight}
          style={{
            background: sectionName.includes('tools') ? '' : undefined,
          }}
          onClick={() => setSection('tools')}
        >
          <div className={`${styles.textRight} ${sectionName.includes('tools') ? styles.big : ''}`}>
            Principles and tools
          </div>
          <div className={styles.numberRight}>{sectionName.includes('tools') ? '2' : ''}</div>
        </div>
        {sectionName.includes('tools') && (
          <div
            className={styles.numRight}
            style={{
              background: sectionName === 'tools_1' ? '#757575' : undefined,
            }}
            onClick={() => setSection('tools_1')}
          />
        )}
        {sectionName.includes('tools') && (
          <div
            className={styles.numRight}
            style={{
              background: sectionName === 'tools_2' ? '#757575' : undefined,
            }}
            onClick={() => setSection('tools_2')}
          />
        )}
        {sectionName.includes('tools') && (
          <div
            className={styles.numRight}
            style={{
              background: sectionName === 'tools_3' ? '#757575' : undefined,
            }}
            onClick={() => setSection('tools_3')}
          />
        )}
        {sectionName.includes('tools') && (
          <div
            className={styles.numRight}
            style={{
              background: sectionName === 'tools_4' ? '#757575' : undefined,
            }}
            onClick={() => setSection('tools_4')}
          />
        )}
        {sectionName.includes('tools') && (
          <div
            className={styles.numRight}
            style={{
              background: sectionName === 'tools_5' ? '#757575' : undefined,
            }}
            onClick={() => setSection('tools_5')}
          />
        )}
      </div>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <div
          className={styles.divRight}
          style={{
            background: sectionName.includes('secure') ? '' : undefined,
          }}
          onClick={() => setSection('secure')}
        >
          <div
            className={`${styles.textRight} ${sectionName.includes('secure') ? styles.big : ''}`}
          >
            Secure data
          </div>
          <div className={styles.numberRight}>{sectionName.includes('secure') ? '3' : ''}</div>
        </div>
        {sectionName.includes('secure') && (
          <div
            className={styles.numRight}
            style={{
              background: sectionName === 'secure_1' ? '#757575' : undefined,
            }}
            onClick={() => setSection('secure_1')}
          />
        )}
        {sectionName.includes('secure') && (
          <div
            className={styles.numRight}
            style={{
              background: sectionName === 'secure_2' ? '#757575' : undefined,
            }}
            onClick={() => setSection('secure_2')}
          />
        )}
        {sectionName.includes('secure') && (
          <div
            className={styles.numRight}
            style={{
              background: sectionName === 'secure_3' ? '#757575' : undefined,
            }}
            onClick={() => setSection('secure_3')}
          />
        )}
        {sectionName.includes('secure') && (
          <div
            className={styles.numRight}
            style={{
              background: sectionName === 'secure_4' ? '#757575' : undefined,
            }}
            onClick={() => setSection('secure_4')}
          />
        )}
      </div>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <div
          className={styles.divRight}
          style={{
            background: sectionName.includes('') ? '' : undefined,
          }}
          onClick={() => setSection('guide')}
        >
          <div className={`${styles.textRight} ${sectionName.includes('guide') ? styles.big : ''}`}>
            The guide
          </div>
          <div className={styles.numberRight}>{sectionName.includes('guide') ? '4' : ''}</div>
        </div>
        {sectionName.includes('guide') && (
          <div
            className={styles.numRight}
            style={{
              background: sectionName === 'guide_1' ? '#757575' : undefined,
            }}
            onClick={() => setSection('guide_1')}
          />
        )}
        {sectionName.includes('guide') && (
          <div
            className={styles.numRight}
            style={{
              background: sectionName === 'guide_2' ? '#757575' : undefined,
            }}
            onClick={() => setSection('guide_2')}
          />
        )}
        {sectionName.includes('guide') && (
          <div
            className={styles.numRight}
            style={{
              background: sectionName === 'guide_3' ? '#757575' : undefined,
            }}
            onClick={() => setSection('guide_3')}
          />
        )}
        {sectionName.includes('guide') && (
          <div
            className={styles.numRight}
            style={{
              background: sectionName === 'guide_4' ? '#757575' : undefined,
            }}
            onClick={() => setSection('guide_4')}
          />
        )}
      </div>
      {/* <div style={{ display: "flex", flexDirection: "column" }}>
        <div
          className={styles.divRight}
          style={{
            background: sectionName.includes("supports") ? "" : undefined,
          }}
          onClick={() => setSection("supports")}
        >
          <div className={styles.textRight}>Achieve</div>
          <div className={styles.numberRight}>
            {sectionName.includes("supports") ? "6" : ""}
          </div>
        </div>
        {sectionName.includes("supports") && (
          <div
            className={styles.numRight}
            style={{
              background: sectionName === "supports_1" ? "#757575" : undefined,
            }}
            onClick={() => setSection("supports_1")}
          ></div>
        )}
      </div>
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div
          className={styles.divRight}
          style={{
            background: sectionName.includes("gateway") ? "" : undefined,
          }}
          onClick={() => setSection("gateway")}
        >
          <div className={styles.textRight}>The Gateway</div>
          <div className={styles.numberRight}>
            {sectionName.includes("gateway") ? "7" : ""}
          </div>
        </div>
        {sectionName.includes("gateway") && (
          <div
            className={styles.numRight}
            style={{
              background: sectionName === "gateway_1" ? "#757575" : undefined,
            }}
            onClick={() => setSection("gateway_1")}
          ></div>
        )}
        {sectionName.includes("gateway") && (
          <div
            className={styles.numRight}
            style={{
              background: sectionName === "gateway_2" ? "#757575" : undefined,
            }}
            onClick={() => setSection("gateway_2")}
          ></div>
        )}
      </div> */}
    </div>
  );
};
